module.exports = __webpack_public_path__ + "img/new-guide-img3.1a7e035a.png";